const ua = window.navigator.userAgent;

const isAndroid = /(Android);?[\s/]+([\d.]+)?/i.test(ua);
const isIpad = /(iPad).*OS\s([\d_]+)/i.test(ua);
const isIpod = /(iPod)(.*OS\s([\d_]+))?/i.test(ua);
const isIphone = !isIpad && /(iPhone\sOS)\s([\d_]+)/i.test(ua);
const isAlipay = /alipayclient/i.test(ua);
const isClient = /NurseFuel/i.test(ua); //护士加App环境里面

const inReview = /inReview=1/i.test(ua); // 根据iOS客户端里面userAgent字段，动态判断吧 inReview，只针对iOS
const isHideIosFunctionality = inReview && isIphone; // inReview=1，隐藏部分功能：tabBar：首页、学习、我的-我的卡券、我的-已购、登录跳转考试、游客模式的学习。inReview=0 表示不隐藏任何功能

// eslint-disable-next-line no-unused-vars
export {
  isIphone,
  isAlipay,
  isAndroid,
  isIpad,
  isIpod,
  isClient,
  isHideIosFunctionality
};
